/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentTypeWithRelations } from '../../models/document-type-with-relations';

export interface AdminGetDocumentTypes$Params {
}

export function adminGetDocumentTypes(http: HttpClient, rootUrl: string, params?: AdminGetDocumentTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentTypeWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, adminGetDocumentTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentTypeWithRelations>>;
    })
  );
}

adminGetDocumentTypes.PATH = '/admin/document-types';
